import type { ExtractPublicPropTypes, PropType } from 'vue'

export const componentType = ['bpm', 'address'] as const
export const uniVueProps = {
  name: String, // 组件名字
  type: String as PropType<(typeof componentType)[number]>, // 组件类型 bpm、 address
} as const
export type UniVueProps = ExtractPublicPropTypes<typeof uniVueProps>
